var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuisBirdEnvironmentBird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 680 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.23,0,0,3.23,-67.53,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,118L25,100L125,0L225,100L225,118L125,18L25,118Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.23,0,0,3.23,-67.53,-5.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204,101L204,245L46,245L46,101L125,22L204,101Z",
    style: {
      fill: "rgb(3,95,15)",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.855558,0,0,0.855558,-329.612,223.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wei\\xDF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.01478,0.138253,-5.76596)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 934.618,
    y: 277.877,
    width: 13.825,
    height: 63.873,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.895817,0,0,0.855476,109.447,36.7266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.652,208.682C946.729,208.682 964.652,226.606 964.652,248.682C964.652,270.759 946.729,288.682 924.652,288.682C902.576,288.682 884.652,270.759 884.652,248.682C884.652,226.606 902.576,208.682 924.652,208.682ZM935.707,226.056C928.717,226.056 923.042,231.73 923.042,238.72C923.042,245.71 928.717,251.384 935.707,251.384C942.696,251.384 948.371,245.71 948.371,238.72C948.371,231.73 942.696,226.056 935.707,226.056Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M897.098,218.049C894.138,220.076 890.089,219.318 888.063,216.357C886.036,213.397 886.795,209.348 889.755,207.322C920.19,186.487 940.521,184.87 960.741,193.313C974.256,198.957 977.97,205.915 996.78,222.717L1044.68,224.572C1047.63,224.686 1050.14,226.778 1050.78,229.664C1051.41,232.551 1050.02,235.503 1047.39,236.851L1001.71,260.261C998.518,261.897 994.598,260.633 992.962,257.441C991.326,254.248 992.589,250.328 995.782,248.692L1019.38,236.602L993.953,235.618C992.458,235.56 991.028,234.988 989.906,233.998C971.332,217.622 968.454,210.622 955.732,205.31C938.964,198.308 922.337,200.772 897.098,218.049Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.994539,0,0,1,5.41026,-0.307088)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 990.648,
    y: 250.377,
    width: 14.057,
    height: 78.018,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(16.1595,0,0,1,-10838.6,-13.3451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 715.229,
    y: 447.087,
    width: 10,
    height: 14,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.4814,-6.76087,0.670476,0.741931,-5006.36,5005.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 715.229,
    y: 447.087,
    width: 10,
    height: 14,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.94014,0,0,0.982558,37.6064,7.73267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.448,443.344L636.448,443.34L670.426,443.34L713.721,406.226L874.995,406.225L926.826,357.778L936.455,367.21L880.615,419.405L880.614,419.411L718.991,419.411L675.68,456.539L675.678,456.537L675.678,456.544L641.989,456.544L594.016,500.858L584.445,491.372L636.444,443.34L636.448,443.344Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.985591,0,4.60514)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 752.108,
    y: 306.426,
    width: 26.948,
    height: 13.17,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.783843,-0.673523,0.674188,0.784618,31.7391,610.155)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 731.691,
    y: 245.175,
    width: 151.302,
    height: 12.596,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.997293,0,0,0.997293,-10.5761,-5.60302)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 573.031,
    cy: 516.22,
    r: 40.12,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.570059,-0.599411,2.66484,2.53435,-798.923,-217.279)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 778.85,
    y: 445.406,
    width: 16.104,
    height: 25.483,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.37393,0,0,1.02128,-223.589,-8.59748)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.952,
    y: 498.722,
    width: 109.58,
    height: 16.614,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.27143,0,0,1.02128,64.9511,-10.8598)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.952,
    y: 498.722,
    width: 109.58,
    height: 16.614,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14272,0,0,1.14272,-112.882,-111.271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M787.39,507.995C806.707,507.995 822.39,523.678 822.39,542.995C822.39,562.312 806.707,577.995 787.39,577.995C768.073,577.995 752.39,562.312 752.39,542.995C752.39,523.678 768.073,507.995 787.39,507.995ZM787.39,525.495C797.049,525.495 804.89,533.337 804.89,542.995C804.89,552.654 797.049,560.495 787.39,560.495C777.732,560.495 769.89,552.654 769.89,542.995C769.89,533.337 777.732,525.495 787.39,525.495Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03007,0,0,1.06,-29.4272,-32.947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.27,534.976L968.001,526.739L978.579,536.719L965.443,549.111L965.443,549.116L965.438,549.116L965.435,549.119L965.432,549.116L932.357,549.116L932.357,534.976L959.27,534.976Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1.69672,58.8198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1004.94,409.284C1027.01,409.284 1044.93,427.207 1044.93,449.284C1044.93,471.361 1027.01,489.284 1004.94,489.284C982.859,489.284 964.935,471.361 964.935,449.284C964.935,427.207 982.859,409.284 1004.94,409.284ZM1004.94,429.284C1015.97,429.284 1024.93,438.246 1024.93,449.284C1024.93,460.322 1015.97,469.284 1004.94,469.284C993.897,469.284 984.935,460.322 984.935,449.284C984.935,438.246 993.897,429.284 1004.94,429.284Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.0662,15.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.963,389.984C595.001,389.984 603.963,398.946 603.963,409.984C603.963,421.023 595.001,429.984 583.963,429.984C572.924,429.984 563.963,421.023 563.963,409.984C563.963,398.946 572.924,389.984 583.963,389.984ZM583.963,399.984C589.482,399.984 593.963,404.465 593.963,409.984C593.963,415.504 589.482,419.984 583.963,419.984C578.444,419.984 573.963,415.504 573.963,409.984C573.963,404.465 578.444,399.984 583.963,399.984Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.787909,0,0,0.787909,201.902,44.8185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.963,389.984C595.001,389.984 603.963,398.946 603.963,409.984C603.963,421.023 595.001,429.984 583.963,429.984C572.924,429.984 563.963,421.023 563.963,409.984C563.963,398.946 572.924,389.984 583.963,389.984ZM583.963,399.984C589.482,399.984 593.963,404.465 593.963,409.984C593.963,415.504 589.482,419.984 583.963,419.984C578.444,419.984 573.963,415.504 573.963,409.984C573.963,404.465 578.444,399.984 583.963,399.984Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15553,0,0,1.15553,201.859,-167.266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.963,389.984C595.001,389.984 603.963,398.946 603.963,409.984C603.963,421.023 595.001,429.984 583.963,429.984C572.924,429.984 563.963,421.023 563.963,409.984C563.963,398.946 572.924,389.984 583.963,389.984ZM583.963,399.984C589.482,399.984 593.963,404.465 593.963,409.984C593.963,415.504 589.482,419.984 583.963,419.984C578.444,419.984 573.963,415.504 573.963,409.984C573.963,404.465 578.444,399.984 583.963,399.984Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02232,0,0,1.02232,273.212,-164.096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.963,389.984C595.001,389.984 603.963,398.946 603.963,409.984C603.963,421.023 595.001,429.984 583.963,429.984C572.924,429.984 563.963,421.023 563.963,409.984C563.963,398.946 572.924,389.984 583.963,389.984ZM583.963,399.984C589.482,399.984 593.963,404.465 593.963,409.984C593.963,415.504 589.482,419.984 583.963,419.984C578.444,419.984 573.963,415.504 573.963,409.984C573.963,404.465 578.444,399.984 583.963,399.984Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.812653,0,0,0.812653,265.432,-17.2883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.963,389.984C595.001,389.984 603.963,398.946 603.963,409.984C603.963,421.023 595.001,429.984 583.963,429.984C572.924,429.984 563.963,421.023 563.963,409.984C563.963,398.946 572.924,389.984 583.963,389.984ZM583.963,399.984C589.482,399.984 593.963,404.465 593.963,409.984C593.963,415.504 589.482,419.984 583.963,419.984C578.444,419.984 573.963,415.504 573.963,409.984C573.963,404.465 578.444,399.984 583.963,399.984Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M811.317,379.859L811.317,391.859L703.181,391.859L666.439,425.724L613.658,425.724L613.658,413.724L661.752,413.724L698.494,379.859L811.317,379.859Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1.9747,-2.96103)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 808.581,
    y: 387.457,
    width: 13.817,
    height: 7.362,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78084,0,0,0.78084,365.947,56.6248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.963,389.984C595.001,389.984 603.963,398.946 603.963,409.984C603.963,421.023 595.001,429.984 583.963,429.984C572.924,429.984 563.963,421.023 563.963,409.984C563.963,398.946 572.924,389.984 583.963,389.984ZM583.963,399.984C589.482,399.984 593.963,404.465 593.963,409.984C593.963,415.504 589.482,419.984 583.963,419.984C578.444,419.984 573.963,415.504 573.963,409.984C573.963,404.465 578.444,399.984 583.963,399.984Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09898,0,0,1.09898,287.485,-99.681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.963,389.984C595.001,389.984 603.963,398.946 603.963,409.984C603.963,421.023 595.001,429.984 583.963,429.984C572.924,429.984 563.963,421.023 563.963,409.984C563.963,398.946 572.924,389.984 583.963,389.984ZM583.963,399.984C589.482,399.984 593.963,404.465 593.963,409.984C593.963,415.504 589.482,419.984 583.963,419.984C578.444,419.984 573.963,415.504 573.963,409.984C573.963,404.465 578.444,399.984 583.963,399.984Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,333.406,138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.963,389.984C595.001,389.984 603.963,398.946 603.963,409.984C603.963,421.023 595.001,429.984 583.963,429.984C572.924,429.984 563.963,421.023 563.963,409.984C563.963,398.946 572.924,389.984 583.963,389.984ZM583.963,399.984C589.482,399.984 593.963,404.465 593.963,409.984C593.963,415.504 589.482,419.984 583.963,419.984C578.444,419.984 573.963,415.504 573.963,409.984C573.963,404.465 578.444,399.984 583.963,399.984Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.023,0,0,1.01709,-17.5012,-6.3019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M757.002,357.819L822.583,301.124L857.095,301.124L857.095,311.966L826.579,311.966L760.995,368.664L760.992,368.661L675.371,368.661L675.371,357.819L757.002,357.819Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.683667,-0.666534,0.565718,0.580259,173.655,485.542)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.932,
    y: 457.734,
    width: 71.254,
    height: 12.595,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.908563,-0.417747,0.170606,0.371053,48.7995,572.749)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 990.527,
    y: 245.549,
    width: 53.418,
    height: 12.886,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.899066,-0.661002,0.703584,0.956984,-83.8309,676.236)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1005.55,
    y: 252.717,
    width: 43.788,
    height: 8.923,
    style: {
      fill: "rgb(13,202,242)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M880.02,447.753C876.156,447.753 873.02,444.617 873.02,440.753C873.02,436.89 876.156,433.753 880.02,433.753C939.213,433.753 989.292,383.05 990.679,327.392C990.775,323.53 993.989,320.473 997.851,320.569C1001.71,320.665 1004.77,323.879 1004.68,327.741C1003.11,390.488 946.753,447.753 880.02,447.753Z",
    style: {
      fill: "rgb(13,202,242)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.994505,0,0,1,4.27939,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 778.85,
    y: 445.406,
    width: 16.104,
    height: 25.483,
    style: {
      fill: "rgb(13,202,242)"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuisBirdEnvironmentBird);
export default __webpack_public_path__ + "static/media/DuisBird_Environment_Bird.8a3074cc0f56244dfa61ce02a678807c.svg";
export { ForwardRef as ReactComponent };